import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ServiceRequestFilters {
  Statuses: string[];
  selectedDate: any;
  UnitId: any[];
  TagIds: any[];
  booleanFilters: string[];
  SubmittedFrom: string | null;
  SubmittedTo: string | null;
  PropertyId: string | null;
  BuildingId: string | null;
  LevelId: string | null;
  ItemTypeId: string | null;
  AssignedToServiceProviderId?: string | null;
  ServiceType?: string | null;
  RequestType?: string | null;
  [key: string]: any;
}

export const INITIAL_FILTERS: ServiceRequestFilters = {
  Statuses: [],
  selectedDate: null,
  UnitId: [],
  TagIds: [],
  booleanFilters: [],
  SubmittedFrom: null,
  SubmittedTo: null,
  PropertyId: null,
  BuildingId: null,
  LevelId: null,
  ItemTypeId: null,
};

const serviceRequestFiltersSlice = createSlice({
  name: 'serviceRequestFilters',
  initialState: INITIAL_FILTERS,
  reducers: {
    applyFilter: (state, action: PayloadAction<{ key: string; data: any }>) => {
      const { key, data } = action.payload;
      state[key] = data;
    },
    applyFilters: (
      state,
      action: PayloadAction<Partial<ServiceRequestFilters>>
    ) => {
      Object.assign(state, action.payload);
    },
    removeFilter: (state, action: PayloadAction<string>) => {
      const key = action.payload;
      state[key] = INITIAL_FILTERS[key];
    },
    clearFilters: () => INITIAL_FILTERS,
  },
});

export const {
  applyFilter: applyFilterAction,
  applyFilters: applyFiltersAction,
  removeFilter: removeFilterAction,
  clearFilters: clearFiltersAction,
} = serviceRequestFiltersSlice.actions;

export default serviceRequestFiltersSlice.reducer;